import { m8API } from 'services/production/m8';
import { AuthorizeWithProvider } from 'types/services';
import { OAUTH2_REDIRECT_TO_KEY } from 'utils/constants';
import { UnreachableError } from 'utils/errors';

export const authorizeWithProvider: AuthorizeWithProvider = async (params) => {
  const { providerName, redirectOnSucceedTo } = params;

  localStorage.setItem(OAUTH2_REDIRECT_TO_KEY, redirectOnSucceedTo);

  switch (providerName) {
    case 'FACEBOOK':
      return m8API.oauth2.authorizeWithFacebook();
    case 'GOOGLE':
      return m8API.oauth2.authorizeWithGoogle();
    default:
      throw new UnreachableError(providerName);
  }
};
